"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Red Bull",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Red_Bull_Airraace_01.jpg"
}, {
  name: "Skoda",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/skoda_logo.jpg?v=9jjed07r7m8"
}, {
  name: "Leica",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Leica-Camera-Logo-3d.jpg?v=7wugf1kbl9m"
}, {
  name: "Siemens",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Siemens_Logo-1.png?v=70ox1dvk9kl"
}, {
  name: "Nike",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/nike.webp?v=vlr07aaa3lh"
}, {
  name: "Hennessey",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/hennessy_logo-1.jpg?v=jkw3pg7x0sc"
}, {
  name: "XBOX",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/xbox-logo-xbox-icon-free-free-vector.jpg?v=38k410spufw"
}, {
  name: "KFC",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/KFC-logo.webp?v=se67ooaofze"
}, {
  name: "Emporio Armani",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/emporio-armani-brand-symbol-logo-white-design-clothes-fashion-illustration-with-black-background-free-vector.jpg?v=jcnhpxamiqe"
}, {
  name: "Becks",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/becks-logo.jpg?v=4iianzgykq4"
}, {
  name: "Nestle",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/b208bae5bb8cfaacb1a67e5e73c71f71.jpg?v=l9gjvui1vn9"
}, {
  name: "VOGUE",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Vogue_India.png"
}, {
  name: "LOUIS VUITTON",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Louis-Vuitton-Logo-SVG-mobile.jpg"
}, {
  name: "HiSTORY CHANNEL",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/History-Emblem-scaled.png"
}, {
  name: "ZDF",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/ZDF_Logo_schwarz-weis.svg_.png"
}, {
  name: "3SAT",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/3sat-logo-schwarz-1500x1000-1.jpg"
}, {
  name: "BR",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/br_MT_02.jpg"
}, {
  name: "SCHWEPPES",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/schweppes.png"
}, {
  name: "HONDA",
  logo: "https://sweeping-walleye.10web.cloud/wp-content/uploads/2026/04/Honda_MT.jpg"
}];
export default function GlobalPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="121108" id="trusted-partners" className="dark bg-background text-foreground border-y border-primary overflow-hidden ![padding:100px_0px_48px_0px]">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={`flex flex-wrap justify-center items-center gap-12 md:gap-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {partners.map((partner, i) => <img key={partner.name} data-index={i} src={partner.logo} alt={`${partner.name} logo`} className="object-contain opacity-100 transition-opacity duration-300 !w-[100px] !h-[100px] hover:opacity-100" />)}
        </div>
      </div>
    </section>;
}